export default "__VITE_ASSET__muc22SwP__"